var _defs, _polyline, _polyline2, _line, _line2, _line3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpackNew241({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}"))), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "a",
    points: "4.37 3.81 12.26 10.91 15.62 10.91"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "a",
    points: "4.37 3.81 12.26 10.91 15.62 10.91"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 0.38,
    y1: 10.93,
    x2: 3.74,
    y2: 10.93
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 2.55,
    y1: 9.74,
    x2: 4.93,
    y2: 12.12
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 5,
    y1: 9.67,
    x2: 2.48,
    y2: 12.19
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpackNew241);
export default __webpack_public_path__ + "static/media/Symbolpack_New_241.4f0cd15632fc7ca988711be8c130cf77.svg";
export { ForwardRef as ReactComponent };